import type { AppThunk } from 'state';
import { DataServiceStaticData } from 'common/dataService/services';
import FetchingStatus from 'constants/statuses/FetchingStatus';
import { setFetching, setLanguages } from '../slice';

function fetchLanguages(): AppThunk {
  return async function fetchLanguagesThunk(dispatch, getState) {
    try {
      const { fetching } = getState().dataService.airports.departureAirports;

      if (fetching === FetchingStatus.InProgress) {
        return;
      }

      dispatch(setFetching(FetchingStatus.InProgress));

      const data = await DataServiceStaticData.getLanguages();

      if (!data) {
        dispatch(setFetching(FetchingStatus.Failed));
        return;
      }

      dispatch(setLanguages(data));
      dispatch(setFetching(FetchingStatus.Succeeded));
    } catch (error) {
      dispatch(setFetching(FetchingStatus.Failed));
      window.Rollbar.error(error);
    }
  };
}

export default fetchLanguages;
